import React from "react";
import "./groupuser.css";

function Groupuser() {
  return (
    <div className="group-page">

      {/* HEADER */}
      <div className="manager-top-header">
        <div>
          <h2>Quản lý nhóm người dùng</h2>

          <div className="manager-breadcrumb">
            Trang chủ / Quản trị hệ thống / Quản lý người dùng
          </div>
        </div>

        <button className="btn-primary">
          <i className="fas fa-plus"></i>
          Thêm nhóm
        </button>
      </div>

{/* FILTER */}
<div className="filter-box">
  <div className="filter-grid">

    {/* SEARCH */}
    <div className="form-group search-group">
      <label>Tìm kiếm</label>

      <div className="search-input-wrap">
        <input
          type="text"
          className="form-control-search"
          placeholder="Nhập tên nhóm..."
        />

        <i className="fa-solid fa-magnifying-glass icon-glass"></i>
      </div>
    </div>

    {/* STATUS */}
    <div className="form-group">
      <label>Trạng thái</label>

      <select className="form-control-status">
        <option>-- Tất cả --</option>
      </select>
    </div>

    {/* DESCRIPTION */}
    <div className="form-group">
      <label>Mô tả</label>

      <input
        type="text"
        className="write-note"
        placeholder="Nhập mô tả..."
      />
    </div>

    {/* BUTTON */}
    <div className="button-group">
      <button className="btn-outline">
        Đặt lại
      </button>

      <button className="btn-primary btn-search">
        <i className="fa-solid fa-magnifying-glass"></i>
        Tìm kiếm
      </button>
    </div>

  </div>
</div>

      {/* CONTENT */}
      <div className="group-wrapper">

        {/* LEFT */}
        <div className="group-card">

          <div className="group-header">
            <h3 className="group-title">
              Danh sách nhóm người dùng
            </h3>

            <button className="reload-btn">
              <i className="fas fa-sync-alt"></i>
            </button>
          </div>

          <div className="table-responsive">

            <table className="group-table">

              <thead>
                <tr>
                  <th>STT</th>
                  <th>Tên nhóm</th>
                  <th>Mô tả</th>
                  <th>Số người dùng</th>
                  <th>Trạng thái</th>
                  <th>Thao tác</th>
                </tr>
              </thead>

              <tbody>

                <tr>
                  <td>1</td>
                  <td className="group-name">
                    Quản trị hệ thống
                  </td>

                  <td>
                    Nhóm có toàn quyền quản trị hệ thống
                  </td>

                  <td>5</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>

                  <td>
                    <div className="action-box">

                      <button className="action-btn">
                        <i className="fas fa-eye"></i>
                      </button>

                      <button className="action-btn">
                        <i className="fas fa-pen"></i>
                      </button>

                      <button className="action-btn delete">
                        <i className="fas fa-trash"></i>
                      </button>

                    </div>
                  </td>
                </tr>

                <tr>
                  <td>2</td>

                  <td className="group-name">
                    Lãnh đạo
                  </td>

                  <td>
                    Nhóm lãnh đạo xem báo cáo tổng hợp
                  </td>

                  <td>12</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>

                  <td>
                    <div className="action-box">

                      <button className="action-btn">
                        <i className="fas fa-eye"></i>
                      </button>

                      <button className="action-btn">
                        <i className="fas fa-pen"></i>
                      </button>

                      <button className="action-btn delete">
                        <i className="fas fa-trash"></i>
                      </button>

                    </div>
                  </td>
                </tr>

                <tr className="active-row">
                  <td>3</td>

                  <td className="group-name">
                    Cán bộ nghiệp vụ
                  </td>

                  <td>
                    Nhóm cán bộ nghiệp vụ nhập liệu, xử lý dữ liệu
                  </td>

                  <td>186</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>

                  <td>
                    <div className="action-box">

                      <button className="action-btn">
                        <i className="fas fa-eye"></i>
                      </button>

                      <button className="action-btn">
                        <i className="fas fa-pen"></i>
                      </button>

                      <button className="action-btn delete">
                        <i className="fas fa-trash"></i>
                      </button>

                    </div>
                  </td>
                </tr>

                <tr>
                  <td>4</td>

                  <td className="group-name">
                    Doanh nghiệp
                  </td>

                  <td>
                    Nhóm dành cho doanh nghiệp kê khai
                  </td>

                  <td>250</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>

                  <td>
                    <div className="action-box">

                      <button className="action-btn">
                        <i className="fas fa-eye"></i>
                      </button>

                      <button className="action-btn">
                        <i className="fas fa-pen"></i>
                      </button>

                      <button className="action-btn delete">
                        <i className="fas fa-trash"></i>
                      </button>

                    </div>
                  </td>
                </tr>

                <tr>
                  <td>5</td>

                  <td className="group-name">
                    Cán bộ thẩm định
                  </td>

                  <td>
                    Nhóm cán bộ thẩm định báo cáo
                  </td>

                  <td>28</td>

                  <td>
                    <span className="status active">
                      Hoạt động
                    </span>
                  </td>

                  <td>
                    <div className="action-box">

                      <button className="action-btn">
                        <i className="fas fa-eye"></i>
                      </button>

                      <button className="action-btn">
                        <i className="fas fa-pen"></i>
                      </button>

                      <button className="action-btn delete">
                        <i className="fas fa-trash"></i>
                      </button>

                    </div>
                  </td>
                </tr>

                <tr>
                  <td>6</td>

                  <td className="group-name">
                    Khách/Đối tác
                  </td>

                  <td>
                    Nhóm khách, đối tác chỉ xem thông tin
                  </td>

                  <td>15</td>

                  <td>
                    <span className="status lock">
                      Tạm khóa
                    </span>
                  </td>

                  <td>
                    <div className="action-box">

                      <button className="action-btn">
                        <i className="fas fa-eye"></i>
                      </button>

                      <button className="action-btn">
                        <i className="fas fa-pen"></i>
                      </button>

                      <button className="action-btn delete">
                        <i className="fas fa-trash"></i>
                      </button>

                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>

          {/* FOOTER */}
          <div className="table-footer">

            <div className="footer-left">
              <span>Hiển thị</span>

              <select className="select-page">
                <option>10</option>
              </select>

              <span>dòng trên mỗi trang</span>
            </div>

            <div className="footer-right">

              <span>1 - 6 trong 6</span>

              <div className="pagination">

                <button className="page-btn">
                  <i className="fas fa-angle-left"></i>
                </button>

                <button className="page-btn active-page">
                  1
                </button>

                <button className="page-btn">
                  <i className="fas fa-angle-right"></i>
                </button>

              </div>

            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="detail-card">

          <div className="detail-header">
            <h3 className="detail-title">
              Chi tiết nhóm: Cán bộ nghiệp vụ
            </h3>
          </div>

          {/* TAB */}
          <div className="tab-box">

            <button className="tab-btn active-tab">
              Thông tin nhóm
            </button>

            <button className="tab-btn">
              Phân quyền
            </button>

          </div>

          {/* INFO */}
          <div className="info-card">

            <div className="edit-box">

              <button className="edit-btn">
                <i className="fas fa-pen"></i>
                Sửa thông tin
              </button>

            </div>

            <div className="detail-group">

              <div className="info-column">

                <div className="info-item">
                  <label>Tên nhóm</label>
                  <p>Cán bộ nghiệp vụ</p>
                </div>

                <div className="info-item">
                  <label>Mô tả</label>

                  <p>
                    Nhóm cán bộ nghiệp vụ nhập liệu,
                    xử lý dữ liệu
                  </p>
                </div>

                <div className="info-item">
                  <label>Trạng thái</label>

                  <span className="status active">
                    Hoạt động
                  </span>
                </div>

              </div>

              <div className="info-column">

                <div className="info-item">
                  <label>Ngày tạo</label>
                  <p>10/05/2024 09:15</p>
                </div>

                <div className="info-item">
                  <label>Người tạo</label>
                  <p>admin</p>
                </div>

                <div className="info-item">
                  <label>Cập nhật lần cuối</label>
                  <p>23/05/2026 10:30</p>
                </div>

              </div>

            </div>
          </div>

          {/* PERMISSION */}
          <div className="permission-card">

            <h4 className="permission-title">
              Phân quyền của nhóm
            </h4>

            <div className="table-responsive">

              <table className="permission-table">

                <thead>
                  <tr>
                    <th>Chức năng</th>
                    <th>Xem</th>
                    <th>Thêm</th>
                    <th>Sửa</th>
                    <th>Xóa</th>
                    <th>Xuất dữ liệu</th>
                  </tr>
                </thead>

                <tbody>

                  <tr>
                    <td>Dashboard</td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                  </tr>

                  <tr>
                    <td>Doanh nghiệp</td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                  </tr>

                  <tr>
                    <td>Báo cáo</td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                  </tr>

                  <tr>
                    <td>Kê khai</td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                  </tr>

                  <tr>
                    <td>Quản lý dữ liệu</td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" /></td>
                    <td><input type="checkbox" /></td>
                  </tr>

                </tbody>
              </table>
            </div>

            <div className="permission-footer">

              <p className="permission-note">
                Ghi chú: Phân quyền được áp dụng cho tất cả người dùng thuộc nhóm.
              </p>

              <button className="permission-btn-update">
                <i className="fas fa-lock"></i>
                Sửa phân quyền
              </button>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
}

export default Groupuser;